
export const customEvents = {
    destroy: 'sjs:destroy',
    init: 'sjs:init'
}
